module.exports = __webpack_public_path__ + "img/horizontal_7_7_pp2_7005.479d7311.png";